// extracted by mini-css-extract-plugin
export default {"wrapper":"_25e26a7","answer":"_4c5d9648","answerText":"_82cf8175"};